
<!--    基础游课程服务-->
<template>
  <div>
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="warning" size="medium" style="width: 120px;" class="operator-btn2" icon="el-icon-service" @click="handleAfterClassShowDlg()">服 务</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        highlight-current-row
        @row-click="rowClick"
        max-height="540"
        border>
        <el-table-column prop="lessonName" label="课程名"></el-table-column>
        <el-table-column prop="teachersInfo" label="教练"></el-table-column>
        <el-table-column prop="userPhone" label="卡号"></el-table-column>
        <el-table-column prop="childName" label="会员姓名" ></el-table-column>
        <el-table-column prop="singInTime" label="签到时间"></el-table-column>
        <el-table-column prop="" label="头像" width="150"></el-table-column>
        <el-table-column prop="childPetName" label="小名"></el-table-column>
        <el-table-column prop="SW_STATU" label="游泳状态"></el-table-column>
        <el-table-column  label="内容评价">
          <el-table-column prop="SW_KIKING" label="踢腿"></el-table-column>
          <el-table-column prop="SW_BREATE" label="闭气/换气"></el-table-column>
          <el-table-column prop="SW_HANDMOVE" label="手部动作"></el-table-column>
          <el-table-column prop="SW_HELPSELF" label="自救课"></el-table-column>
          <el-table-column prop="SW_SPEED" label="速度"></el-table-column>
        </el-table-column>
        <el-table-column prop="serviceTeacherName" label="服务泳师"></el-table-column>
        <el-table-column prop="point" label="满意度" ></el-table-column>
        <el-table-column prop="finish" label="完成" ></el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="课后服务"
      :visible.sync="visibleAfterClassService"
      width="50%"
      center>
      <after-class-service v-bind:service-items="serviceItems"  :key="afterClassServiceDetailrefresh"  @onBtnOK="onBtnOKSerivce" v-bind:detail="selectRow"></after-class-service>
    </el-dialog>
    <el-dialog
      title="图片预览"
      :visible.sync="visibleVisitPic"
      width="50%"
      center>
      <visit-pics :key="refreVisitPic" :pics="visitPicList" ></visit-pics>
    </el-dialog>
    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show = "showWordDlg" @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>
  import timeUtils from "../../../../utils/timeUtils";
  import AfterClassService from "../../../my-store/component/AfterClassService";
  import {queryService, workerService} from "../../../../api/AfterClassService";
  import commonUtils from "../../../../utils/commonUtils";
  import WorkerWord from "../../../../components/WorkerWord/WorkerWord";
  import messageUtils from "../../../../utils/messageUtils";
  import {getClassServiceAllItem, getClassServiceItem} from "../../../../api/StoreSetting";
  import globaldata from "../../../../utils/globaldata";
  import {EClassServiceItemType} from "../../../../utils/enumsUtil";
  import VisitPics from "../../../components/VisitPics";

  export default {
    name: 'AfterClassServiceCf',
    components: {VisitPics, WorkerWord, AfterClassService},
    props: {
      dataList : Array,
      allWorker:Array,
    },
    data() {
      return {
        selectRow:null,
        tableData:[],
        visibleAfterClassService:false,     //课后服务
        visibleVisitPic:false,              //图片预览
        visitPicList:[],
        refreVisitPic:"",

        //课后服务参数
        afterClassServiceDetail:{},
        afterClassServiceDetailrefresh:"",
        serviceItems:[],

        refreshWord:"",
        showWordDlg:false,
        tData:null,
        wordType : 0,
      }
    },
    mounted(){



    },
    created() {
      this.init();
    },
    methods: {
      rowClick(row, column, event){
        this.selectRow = row;
      },
      init(){
        this.onGetServiceAllItemOptions();
        this.tableData = this.dataList;


        for (let i = 0;i< this.tableData.length;++i){


          let td =  this.tableData[i];
          if (commonUtils.isObjectNull(td)){
            console.log("onGetServiceAllItemOptions continue-------------",td)
            continue;
          }

          if (commonUtils.isObjectNull(td.photo) == false){
            td.picUrls = JSON.parse(td.photo)
            td.hasPic = true;
          }else {
            td.picUrls =[]
            td.hasPic = false;
          }
          if (!commonUtils.isStringNull(td.classEvaluation)) {
            let classEvaluation = JSON.parse(td.classEvaluation);
            td.SW_STATU =classEvaluation.SW_STATU
            td.SW_KIKING =classEvaluation.SW_KIKING
            td.SW_BREATE =classEvaluation.SW_BREATE
            td.SW_HANDMOVE =classEvaluation.SW_HANDMOVE
            td.SW_HELPSELF =classEvaluation.SW_HELPSELF
            td.SW_SPEED =classEvaluation.SW_SPEED
          }
          td.finish = "未完成";

          if (commonUtils.isObjectNull(td.serviceTeacher) == false && td.serviceTeacher >0){
            let serviceTeacherName = commonUtils.getObjectBuyId(this.allWorker,td.serviceTeacher).name;
            td.serviceTeacherName = serviceTeacherName;
          }

          if (commonUtils.isObjectNull(td.classEvaluation) == false && td.classEvaluation.length >0){
            td.finish = "完成";
          }

          td.classDay = timeUtils.transDay(td.dayTime)
          td.classTime = timeUtils.transTimeHM(td.classStartTime) + "~" +timeUtils.transTimeHM(td.classEndTime);


        }

      },

      handleAfterClassShowDlg(){
        if (this.selectRow == null){
          messageUtils.errorMsg(this,"请选择一条数据");
          return;
        }
        this.visibleAfterClassService = true;
      },
      onBtnOKSerivce(param){

        this.doRefreshWord(true,1,param);
      },

      doRefreshWord(show,wordType,tData){
        this.wordType = wordType;
        this.tData = tData;
        this.refreshWord = new Date().getTime();
        this.showWordDlg = show;
      },
      closeWordDlg(){
        this.wordType = 0;
        this.refreshWord = new Date().getTime();
        this.showWordDlg = false;
      },

      doWorkerService(param){
        workerService(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          messageUtils.successMsg(this,response.message)
          this.closeWordDlg();
          this.visibleAfterClassService = false;
          this.$emit('onServiceOk');
        })
      },

      handleWord(wordType,tData){

        if (wordType == 1){
          this.doWorkerService(tData)
        }
      },


      onVisitPics(pics){

        this.visitPicList = pics;
        this.visibleVisitPic = true;
        this.refreVisitPic = new Date().getTime();
      },

      /**
       * 获取所有服务的选项
       */
      onGetServiceAllItemOptions(){
        let param = {
          id:globaldata.getAdminStore().storeFrontId
        }
        getClassServiceAllItem(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.serviceItems = data;

          this.afterClassServiceDetailrefresh = new  Date().getTime();
        })

      },






    }
  }
</script>






// WEBPACK FOOTER //
// src/views/service/after-class-service/components/AfterClassServiceCf.vue